import React, { useState } from "react";
import ReactDOM from "react-dom";
import { Text } from "@sitecore-jss/sitecore-jss-react";
import Modal from "react-modal";
import "./styles.scss";

const Spinner = (props) => {

  return (
    <div className="loader__overlay">
     <div className="loader"></div>
    </div>
  );
};
export default Spinner;
